import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/welcome',
    name: 'Dashboard',
    meta: {
      title: t('router.dashboard'),
      icon: 'vi-ant-design:dashboard-filled',
      alwaysShow: true
    },
    children: [
      {
        path: 'welcome',
        component: () => import('@/views/Dashboard/Welcome.vue'),
        name: 'Welcome',
        meta: {
          title: 'Welcome',
          noCache: true,
          affix: true
        }
      }
    ]
  }
]

export default dashboardRoutes
